import React from 'react';
import styles from './customRenderValue.module.scss';

export const customRenderValue = (value: any[], placeholder = '') => (
  <span className={styles.wrapper}>
    <span className={styles.placeholder}>{value && placeholder}</span>
    <span className={styles.count}>{value && value?.length}</span>
  </span>
);
